/**
 * Idea Configuration
 * 
 * UI configuration for idea categories, statuses, and priorities.
 * Uses design tokens exclusively.
 */

import { color } from '../../../shared/tokens/mobile';
import {
  IdeaCategory,
  IdeaStatus,
  IdeaPriority,
  IdeaCategoryConfig,
  IdeaStatusConfig,
  IdeaPriorityConfig,
} from '../../../shared/types/idea';

// =============================================================================
// CATEGORY CONFIG
// =============================================================================

export const CATEGORY_CONFIG: Record<IdeaCategory, IdeaCategoryConfig> = {
  improvement: {
    key: 'improvement',
    label: 'Improvement',
    icon: 'trending-up-outline',
    color: color.success,
  },
  concern: {
    key: 'concern',
    label: 'Concern',
    icon: 'warning-outline',
    color: color.error,
  },
  question: {
    key: 'question',
    label: 'Question',
    icon: 'help-circle-outline',
    color: color.info,
  },
  opportunity: {
    key: 'opportunity',
    label: 'Opportunity',
    icon: 'star-outline',
    color: color.warning,
  },
  general: {
    key: 'general',
    label: 'General',
    icon: 'bulb-outline',
    color: color.textSecondary,
  },
};

// =============================================================================
// STATUS CONFIG
// =============================================================================

export const STATUS_CONFIG: Record<IdeaStatus, IdeaStatusConfig> = {
  open: {
    key: 'open',
    label: 'Open',
    icon: 'radio-button-off-outline',
    color: color.info,
  },
  under_review: {
    key: 'under_review',
    label: 'Under Review',
    icon: 'eye-outline',
    color: color.warning,
  },
  approved: {
    key: 'approved',
    label: 'Approved',
    icon: 'checkmark-circle-outline',
    color: color.success,
  },
  rejected: {
    key: 'rejected',
    label: 'Rejected',
    icon: 'close-circle-outline',
    color: color.error,
  },
  implemented: {
    key: 'implemented',
    label: 'Implemented',
    icon: 'checkmark-done-outline',
    color: color.primary,
  },
  deferred: {
    key: 'deferred',
    label: 'Deferred',
    icon: 'time-outline',
    color: color.textMuted,
  },
};

// =============================================================================
// PRIORITY CONFIG
// =============================================================================

export const PRIORITY_CONFIG: Record<IdeaPriority, IdeaPriorityConfig> = {
  low: {
    key: 'low',
    label: 'Low',
    color: color.textMuted,
  },
  medium: {
    key: 'medium',
    label: 'Medium',
    color: color.info,
  },
  high: {
    key: 'high',
    label: 'High',
    color: color.warning,
  },
  critical: {
    key: 'critical',
    label: 'Critical',
    color: color.error,
  },
};

// =============================================================================
// ARRAYS FOR ITERATION
// =============================================================================

export const CATEGORIES = Object.values(CATEGORY_CONFIG);
export const STATUSES = Object.values(STATUS_CONFIG);
export const PRIORITIES = Object.values(PRIORITY_CONFIG);

